<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row>
      <b-col>
        <span :class="`size-${ButtonSize}`">Salonlar</span>
      </b-col>

      <b-col class="text-right mb-3 top-buttons">
        <b-btn class="m-1" type="button" variant="danger" to="/Settings" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth >= 340">Ayarlar</span>
        </b-btn>

        <b-btn to="/Settings/Places/Add" class="btn-info m-1" :size="ButtonSize">
          <i class="material-icons mifix">add</i>
          <span class="ml-1">Salon Ekle</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-table
      striped
      hover
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items="Places"
      :fields="fields"
      responsive
    >
      <template v-slot:cell(Name)="data">
        <div class="ws-nowrap">{{ data.item.Name }}</div>
      </template>

      <template v-slot:cell(Actions)="data">
        <b-btn size="sm" :to="`/Settings/Places/${data.item.ID}`" class="mr-2">Düzenle</b-btn>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      sortBy: "Name",
      sortDesc: false,
      fields: [
        { key: "Name", label: "Salon Adı", sortable: true },
        { key: "TablesCount", label: "Masa Sayısı", sortable: true },
        { key: "Sort", label: "Sıralama", sortable: true },
        { key: "Actions", label: "İşlem", sortable: false }
      ]
    };
  },
  computed: {
    ...mapState(["StoreData", "ScreenWidth", "ButtonSize"]),
    Places() {
      let _Places = [];

      if (this.StoreData.Places)
        for (let i in this.StoreData.Places) {
          const _Place = this.StoreData.Places[i];

          _Places.push({
            ID: _Place.ID,
            Name: _Place.Name,
            TablesCount: _Place.Tables ? Object.keys(_Place.Tables).length : 0,
            Sort: _Place.Sort
          });
        }

      return _Places;
    }
  },
  mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
